<mat-toolbar>
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon" (click)="drawer.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <span>Buddyrun Backoffice</span>
  <span class="example-spacer"></span>
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon" [matMenuTriggerFor]="menu">
    <mat-icon>settings</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="logout()">Logout</button>
  </mat-menu>
</mat-toolbar>

<mat-drawer-container class="example-container" autosize hasBackdrop="true" >
  <mat-drawer #drawer class="example-sidenav" mode="side">
    <div class="menu">
      <button  mat-stroked-button (click)="router.navigateByUrl('categories')">
        Categories
      </button>
      <button  mat-stroked-button (click)="router.navigateByUrl('products')">
        Products
      </button>
      <button  mat-stroked-button (click)="router.navigateByUrl('store')">
        Store
      </button>
    </div>
    </mat-drawer>

  <div class="example-sidenav-content">
    <ng-content></ng-content>
  </div>

</mat-drawer-container>